import { UserClientPermissions, UserResponse, UserUpdateRequest } from '@key-telematics/fleet-api-client';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { AdminEditorService } from '../../admin.service';
import { FormSectionHandler } from '../entity.handler';

export class UserAssetPermissionsSectionHandler implements FormSectionHandler<UserResponse, UserClientPermissions> {

    type = 'form';
    icon = 'clipboard-list';
    bulk = false;

    title = this.translate('TITLE');
    description = this.translate('DESC');

    constructor(
        public admin: AdminEditorService,
        public ownerId: string
    ) {
    }

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.USER.ASSET_PERMISSIONS.${key}`, values);
    }

    applyUpdate(entity: UserResponse, payload: UserUpdateRequest): Promise<UserResponse> {
        return this.admin.applyUpdate(api => api.accounts.updateUser(entity.id, payload));
    }

    async mapEntityToEditor(entity: UserResponse): Promise<UserClientPermissions> {
        return Promise.resolve({
            assets: entity.permissions?.clients?.[this.ownerId]?.assets ?? null
        });
    }

    async mapEditorToEntity(entity: UserUpdateRequest, newPermissions: UserClientPermissions): Promise<UserUpdateRequest> {
        entity.permissions = entity.permissions ?? { clients: {} };
        entity.permissions.clients[this.ownerId] = newPermissions?.assets?.length > 0 ? newPermissions : null;
        return entity;
    }

    async getFields(): Promise<FormBuilderField[]> {
        const fields: FormBuilderField[] = [
            {
                id: 'assets',
                title: this.translate('FIELDS.ASSETS'),
                type: 'assetfilter',
                required: false,
                options: {
                    ownerId: this.ownerId,
                    allowedAssetTypes: ['asset'],
                    excludeCategories: true,
                },
            },

        ];
        return fields;
    }

}

